export default state => {
  return state.form
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/getters/orderCustomForm.js